import React, { Component } from "react";
import Draggable from "react-draggable";

export default class Drag2 extends Component {
  state = {
    disabled: false
  };

  toggleDraggable = () =>
    this.setState(prevState => ({ disabled: !this.state.disabled }));

  render = () => {
    const { disabled } = this.state;
    return (
      <div className="container">
        <Draggable disabled={disabled} bounds="parent">
          <div style={{ width: "fit-content" }} className="draggable">
            <h4 style={{ height: 20, userSelect: "none" }}>
              {this.props.data}
            </h4>
          </div>
        </Draggable>
      </div>
    );
  };
}
